export default __webpack_public_path__ + "static/media/acquisition-points_sp.8869a18e.jpg";